import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi everyone! I’m <span className="purple">Anshul Kumar</span>{" "}
            from <span className="purple">Bahadurgarh, Haryana, India</span>.
            <br />
            I’m an <span className="purple">Aspiring Software Development Engineer</span> passionate about Data Structures & Algorithms with a strong foundation in problem-solving.
            <br />
            Currently pursuing my B.Tech in{" "}
            <span className="purple">Computer Science and Engineering</span> from{" "}
            <span className="purple">VIT Bhopal</span> with expertise in competitive programming.
            <br />
            <br />
            Outside of coding, I love engaging in activities that keep me
            creative and inspired:
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Competitive Programming 🏆
            </li>
            <li className="about-activity">
              <ImPointRight /> Building Distributed Systems 💻
            </li>
            <li className="about-activity">
              <ImPointRight /> Open Source Contributions 🌐
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Anshul</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
